import { createContext } from 'react'

import type { SnackbarType } from './SnackbarType'

export type SnackbarOptions = {
	message: string
	type?: SnackbarType
	duration?: number
}

export type Handler<TArgs extends Array<any>> =
	| ((...args: TArgs) => Awaitable<string | null>)
	| ((...args: TArgs) => Awaitable<void>)

export type SnackbarContext = {
	showSnackbar: (options: SnackbarOptions) => void
	handleSnackbars: <TArgs extends Array<any>>(
		func: Handler<TArgs>,
		handlers?: OptionalRecord<number | 'default', Handler<TArgs> | string | null>,
	) => (...args: TArgs) => Promise<void>
}

export const context = createContext<SnackbarContext>({
	showSnackbar: () => {
		throw new Error('No snackbar context provided')
	},
	handleSnackbars: () => async () => {
		throw new Error('No snackbar context provided')
	},
})
